import ActivateDeactivateButton from "@app/components/activate-deactivate-button.tsx";
import ActivateDeactivateIndicator from "@app/components/activate-deactivate-indicator.tsx";
import { AssignmentModel } from "@app/data/engine.ts";
import { formatDate } from "@app/helpers/time-helper.ts";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { Link } from "@tanstack/react-router";
import { createColumnHelper, IconButton } from "bi-lib";

interface Props {
    onActivateDeactivate: (id: number, isActive: boolean) => void;
    rowCount: number;
}

const columnHelper = createColumnHelper<AssignmentModel>();
export const AssignmentsTableDefinition = ({ onActivateDeactivate, rowCount }: Props) => [
    columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (item) => (
            <Link
                to={"/assignment/$assignmentId"}
                params={{ assignmentId: item.row.original.assignmentId!.toString() }}
            >
                <IconButton tooltip={"Edit Assignment"}>
                    <EditIcon />
                </IconButton>
            </Link>
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.displayName, { id: "name", header: "Name" }),
    columnHelper.accessor((x) => x.extensionCode, { id: "extension", header: "Extension" }),
    columnHelper.accessor((x) => x.startDate, {
        id: "start",
        header: "Start Date",
        cell: (item) => formatDate(item.getValue()),
    }),
    columnHelper.accessor((x) => x.endDate, {
        id: "end",
        header: "End Date",
        cell: (item) => formatDate(item.getValue()),
    }),
    columnHelper.accessor((x) => x.assignDesc, { id: "description", header: "Description" }),
    columnHelper.accessor((x) => x.clientName, { id: "client", header: "Client" }),
    columnHelper.accessor((x) => x.isActive, {
        id: "active",
        header: () => (
            <Box display={"flex"} alignItems={"center"} gap={2}>
                Active
                <ActivateDeactivateIndicator />
            </Box>
        ),
        cell: (item) => (
            <ActivateDeactivateButton
                isActive={item.getValue()!}
                onClick={() => onActivateDeactivate(item.row.original.assignmentId!, !item.getValue()!)}
            />
        ),
    }),
];
